/**
 * Seconds of a video actually played, to a tenth. `played` ranges are merged,
 * so a rewatched stretch counts once and a skipped one not at all.
 */
export function videoSecondsPlayed(
  played: Pick<TimeRanges, "length" | "start" | "end"> | undefined,
): number {
  if (!played) {
    return 0;
  }
  let seconds = 0;
  for (let i = 0; i < played.length; i++) {
    seconds += played.end(i) - played.start(i);
  }
  return Math.round(seconds * 10) / 10;
}
